import React from "react";
import {useHistory} from "react-router-dom";
import {appdata, load} from "../../../logic_tmp/appdata/AppData";


export default function PayPalButtons() {
    const [paid, setPaid] = React.useState(false);
    const [error] = React.useState(null);
    const paypalRef = React.useRef();


    function loadPaypalSDK(currency) {
        // Удаляем предыдущий экземпляр SDK, если он существует
        const existingScript = document.getElementById('paypal-sdk');
        if (existingScript) {
            existingScript.remove();
        }
        // Создаем новый элемент script и загружаем SDK
        const script = document.createElement('script');
        script.src = `https://www.paypal.com/sdk/js?client-id=Ac-wTwnq_bTTe9LUTz2Rg0C7JTbbnJqr9_j4yJkDD0Xw9PxHHWxfSHdhIMMSKvE3IwuOeApcxaHVDKKI&currency=${currency}`;
        script.id = 'paypal-sdk';
        script.onload = () => {
            window.paypal
                .Buttons({
                    createOrder: (data, actions) => {
                        return actions.order.create({
                            intent: "CAPTURE",
                            purchase_units: [
                                {
                                    description: appdata.productCode + "#" + appdata.orderId + "#",
                                    amount: {
                                        currency_code: currency,
                                        value: appdata.amount,
                                    },
                                },
                            ],
                        });
                    },
                    onApprove: async (data, actions) => {
                        const order = await actions.order.capture();
                        setPaid(true);
                    },
                    onError: (err) => {
                        //   setError(err),
                        console.error(err);
                    },
                })
                .render(paypalRef.current);
        };
        script.onerror = () => {
            console.error("Error loading PayPal SDK");
        };
        document.body.appendChild(script);
    }


    // To show PayPalButtons buttons once the component loads
    React.useEffect(() => {
        let curr3 = "EUR"
        if (appdata.currency === "$")
            curr3 = "USD"
        load();
        loadPaypalSDK(curr3);

    }, []);

    // If the payment has been made
    if (paid) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        let history = useHistory();
        if ("DONATE" !== appdata["eventType"])
            history.push('/ok')
        else
            history.push('/thankyoushort')
        return <div>Платеж успешен!</div>;
    }

    // If any error occurs
    if (error) {
        return <div>Что-то пошло не так! Пожалуйста попробуйте еще.</div>;
    }
    // Default Render
    return (
        <div>
            <div ref={paypalRef} />
        </div>
    );
}
